import React from "react";
import { ChevronUp, ChevronDown } from "react-feather";
import { Button } from "@mui/material";

import { ORDER_BY, ORDER_DIRECTIONS } from "../../../../storage/constants";

const CustomHeadLabel = ({
  title,
  setOrderBy,
  orderKey,
  orderBy,
  isOrderedByColumn,
  setOrderDirection,
  orderDirection,
}) => {
  const handleOrderToggle = () => {
    if (orderBy !== orderKey) {
      setOrderBy(orderKey);
      return setOrderDirection(ORDER_DIRECTIONS.ASCENDING);
    }

    if (orderDirection === null) {
      setOrderBy(orderKey);
      return setOrderDirection(ORDER_DIRECTIONS.ASCENDING);
    }
    if (orderDirection === ORDER_DIRECTIONS.ASCENDING) {
      setOrderBy(orderKey);

      return setOrderDirection(ORDER_DIRECTIONS.DESCENDING);
    }
    if (orderDirection === ORDER_DIRECTIONS.DESCENDING) {
      setOrderBy(ORDER_BY.ID);
      return setOrderDirection(null);
    }
    return null;
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <Button
        onClick={handleOrderToggle}
        endIcon={
          !isOrderedByColumn ? null : orderDirection ===
            ORDER_DIRECTIONS.ASCENDING ? (
            <ChevronDown style={{ height: 16, width: 16, color: "darkgrey" }} />
          ) : (
            <ChevronUp style={{ height: 16, width: 16, color: "lightgray" }} />
          )
        }
      >
        <span style={{ color: "black" }}>{title}</span>
      </Button>
    </div>
  );
};

export default CustomHeadLabel;
